<template>
  <div>
    <month-end-table
      :chnl="Channels.WHOLESALER"
      :director-code="user"
      :is-territorial-director="isTerritorialDirector"
      class="mt-2"
    />
    <month-end-table
      :chnl="Channels.RETAIL"
      :is-territorial-director="isTerritorialDirector"
      :director-code="user"
      class="mb-2"
    />

    <v-simple-table>
      <template #default>
        <thead class="table-heading">
          <tr class="custom-ligth-row">
            <th colspan="7" class="text-center">
              <div class="d-flex justify-center">
                <b class="pr-8 pl-8 text-dark"
                  >Facturación neta por trimestre (Miles)</b
                >
              </div>
            </th>
          </tr>
          <tr>
            <th
              v-for="(item, index) in quarters"
              :key="index"
              class="text-center text-dark"
            >
              <b class="pre-line">{{ item.date }}</b>
            </th>
          </tr>
        </thead>
        <tbody v-if="!orders.error">
          <tr v-if="!orders.loading">
            <td v-for="item in quarters.length" :key="item">
              {{
                formatNumber(
                  orders.data?.billing?.yearlyNet[`q${item}`] / 1000,
                  '$',
                  0
                )
              }}
            </td>
          </tr>
          <tr v-else>
            <td colspan="8">
              <v-progress-linear indeterminate color="cyan" />
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <alert-prominent v-if="orders.error" :error-message="orders.error" />
  </div>
</template>
<script>
  import { getOrders } from '@/repositories/Daily';

  import { Channels } from '@/core/constants/channelConstants';
  import activeUsernameMixin from '@/mixins/activeUsernameMixin';
  import { MetaRoles } from '@/core/constants/roleConstants.js';
  import numbersFormats from '@/mixins/numbersFormats';
  import service from '@/mixins/service';

  import MonthEndTable from '../components/MonthEndTable.vue';
  import AlertProminent from '@/components/AlertProminent.vue';

  export default {
    name: 'MonthEnd',
    components: {
      MonthEndTable,
      AlertProminent,
    },
    mixins: [numbersFormats, service, activeUsernameMixin],
    props: {
      user: {
        required: true,
        type: String,
      },
      chnl: {
        required: true,
        type: String,
      },
    },

    data: () => ({
      groupOverviewData: [],
      orders: {
        loading: false,
        data: [],
        error: '',
      },
      quarters: [],
      Channels,
    }),
    computed: {
      isTerritorialDirector() {
        return this.$route.meta.role === MetaRoles.Regional;
      },
      username() {
        return this.activeUsername?.username ?? this.user.sap_id;
      },
    },
    mounted() {
      this.loadOrders();
    },
    created() {
      this.quarters = this.calcularUltimosTrim(5);
    },
    methods: {
      async loadOrders() {
        this.orders.loading = true;
        this.orders.error = '';
        try {
          this.orders.data = await getOrders(this.username, this.chnl);
        } catch (error) {
          this.orders.error =
            'No se ha podido cargar la facturación, correctamente. Por favor intente más tarde';
        } finally {
          this.orders.loading = false;
        }
      },
    },
  };
</script>
<style scoped src="../../../../../public/css/managercustom.css"></style>
